type JQueryGlobals = {
    $?: any;
    jQuery?: any;
};

/**
 * This hook is only a facade for the global window.$, intended as a single piece
 * of indirection to access jQuery.
 *
 * NOTE: we try to move away from jQuery. Do not use this in new code.
 */
export const useJquery = (): { $: any; jQuery: any } => {
    const globals = globalThis as unknown as JQueryGlobals;
    const $ = globals.$ ?? globals.jQuery;
    const jQuery = globals.jQuery ?? globals.$;

    if (!$ || !jQuery) {
        throw new Error(
            'jQuery is not available on window. Ensure legacy CDN scripts load before the app.'
        );
    }

    return { $, jQuery };
};
